import { css, type Theme } from "@emotion/react";

export const brandingRow = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: ${theme.ds5.gap[400]};
  width: 100%;
  margin-bottom: ${theme.ds5.gap[600]};
`;

export const partnerLogo = css`
  max-height: 80px;
  max-width: 320px;
  width: auto;
  height: auto;
  object-fit: contain;
`;

export const poweredByBadge = (theme: Theme) => css`
  display: inline-flex;
  align-items: center;
  gap: ${theme.ds5.gap[200]};
  padding: ${theme.ds5.padding.static[300]} ${theme.ds5.padding.static[400]};
  border: 1px solid ${theme.ds5.neutral.border};
  border-radius: ${theme.ds5.radius.background.rounded};
  background-color: ${theme.ds5.neutral.backgroundLevel0};
`;

export const poweredByLogo = css`
  flex-shrink: 0;
`;
